module.exports = __webpack_public_path__ + "img/gslogo.6c1908a5.png";